import {Component, OnInit, AfterViewInit, TemplateRef, ViewChild} from '@angular/core';
import {PageService} from "./services/page.service";
import {CookieService} from "ngx-cookie-service";
import {Router} from "@angular/router";
import {NoopScrollStrategy} from "@angular/cdk/overlay";
import {MatDialog} from "@angular/material/dialog";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent implements  OnInit, AfterViewInit {
  title = 'varenka_front';

 @ViewChild('countryDialog') myDialog: TemplateRef<any>;
  private dialogRef: any;

 @ViewChild('cookieDialog') cookieDialog: TemplateRef<any>;
  private cookieDialogRef: any;

  constructor(private pageService: PageService,
              private cookieService: CookieService,
              private router: Router,
              public dialog: MatDialog,


  ) {

  }

  onActivate() {

    let scrollElement = document.getElementById('content')

    scrollElement?.scrollTo(0, 0)
    scrollElement?.scroll(0,0)
  }

  ngOnInit(): void {

    this.pageService.setMetaTagBase();
    this.pageService.setBaseTitle();

  }

  ngAfterViewInit(): void {
    if (!this.cookieService.get('country')) {
        this.dialogRef = this.dialog.open(this.myDialog,
          {
            data: 123, width: '80vw',
            scrollStrategy: new NoopScrollStrategy(),
            disableClose: true,
            position:{top: '200px'}


          });



    } else  {
         this.pageService.redirectCountryDns(this.cookieService.get('country'));

    }

    if (this.cookieService.get("cookie-consent") !== "accepted") {
      this.cookieDialogRef = this.dialog.open(this.cookieDialog,
            {
              data: 123, width: '100%',
              scrollStrategy: new NoopScrollStrategy(),
              disableClose: true,
              position:{bottom: '10px'},
              hasBackdrop: false


            });

        this.cookieDialogRef.afterClosed().subscribe((result: any) => {
                  if (result) {
                    this.cookieService.set("cookie-consent", 'accepted', 90);
                  }
                });
    }

  }



  navigate(event: any) {
    this.pageService.navigate(event, {});
  }

  acceptCookies() {


  }


}
